import script from "./SalaryCalculator.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalaryCalculator.vue?vue&type=script&setup=true&lang=ts"

import "./SalaryCalculator.vue?vue&type=style&index=0&id=444f5ab1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-444f5ab1"]])

export default __exports__